<div class="highcharts-tooltip">
  <span>
    <div>
      <span class="metric-tooltip title tile_body">Current Month</span>
      <span
        class="metric-tooltip value tooltip_value"
        [ngStyle]="{ color: data.color }"
      >
        {{ data.y | number }}{{ dataSuffix }}
      </span>
    </div>
    <div
      class="metric-tooltip description body_tooltip_text"
      [innerHTML]="definition"
    ></div>
  </span>
</div>
